import Vue from "vue";
import VueRouter, { Location, Route } from "vue-router";

import LayoutComponent from "@layouts/layout.vue";

import DefaultTitleComponent from "@layouts/default/default-title.vue";
import DefaultNavigatorComponent from "@layouts/default/default-navigator.vue";
import DefaultMenuComponent from "@layouts/default/default-menu.vue";

import LoginComponent from "@views/account/login.vue";

import PageNewsComponent from "@pages/page-news.vue";
import PageSeoComponent from "@pages/page-seo.vue";
import PageJob_openingsComponent from "@pages/page-job_openings.vue";
import PageUsersComponent from "@pages/page-users.vue";
import PagePartnersComponent from "@pages/page-partners.vue";
import PageBannersComponent from "@pages/page-banners.vue";
import PageMobileUsersComponent from "@pages/page-mobile-users.vue";
import PageMobileUsersDevicesComponent from "@pages/page-mobile-users-devices.vue";
import PageContractsOrganizationComponent from "@pages/page-contracts-organization.vue";
import PageKpiComponent from "@pages/page-kpi.vue";
import PageKpiUserComponent from "@pages/page-kpi-user.vue";
import PageKpiUserHistoryComponent from "@pages/page-kpi-user-history.vue";

import PageGpsTrackerComponent from "@pages/page-gps-tracker.vue";
import PageMapComponent from "@pages/page-map.vue";

import PageContractsComponent from "@pages/page-contracts.vue";

import WsResponseModel from "./DataSource/api/SchemaBuilderServer/Models/WsResponseModel";
import UserResponse from "./DataSource/api/RunPay/Admin/IServices/Models/Accounts/UserResponse";

Vue.use(VueRouter);
const loginRoute = {
  name: "login"
};
const routeLangPrefix = ":lang([a-z][a-z])?";

const router = new VueRouter({
  mode: "history",
  routes: [
    {
      name: "default",
      path: "/:lang([a-z][a-z])?",
      component: LayoutComponent,
      children: [
        {
          name: "users",
          path: "users",
          component: PageUsersComponent,
          meta: {
            title: "Пользователи"
          }
        },
        {
          name: "partners",
          path: "partners",
          // component: PageUsersComponent,
          components: {
            default: PagePartnersComponent,
            // title: DefaultTitleComponent,
            // navigator: DefaultNavigatorComponent,
            menu: DefaultMenuComponent
          },
          meta: {
            title: "Партнеры"
            // panelTitle: "Employees panel"
          },
          children: []
        },
        {
          name: "banners",
          path: "banners",
          // component: PageUsersComponent,
          components: {
            default: PageBannersComponent,
            // title: DefaultTitleComponent,
            // navigator: DefaultNavigatorComponent,
            menu: DefaultMenuComponent
          },
          meta: {
            title: "Баннер"
            // panelTitle: "Employees panel"
          },
          children: []
        },
        {
          name: "news",
          path: "",
          // component: PageUsersComponent,
          components: {
            default: PageNewsComponent,
            // title: DefaultTitleComponent,
            // navigator: DefaultNavigatorComponent,
            menu: DefaultMenuComponent
          },
          meta: {
            title: "Новости"
            // panelTitle: "Employees panel"
          },
          children: []
        },
        {
          name: "job_openings",
          path: "job_openings",
          // component: PageUsersComponent,
          components: {
            default: PageJob_openingsComponent,
            // title: DefaultTitleComponent,
            // navigator: DefaultNavigatorComponent,
            menu: DefaultMenuComponent
          },
          meta: {
            title: "Вакансии"
            // panelTitle: "Employees panel"
          },
          children: []
        },
        {
          name: "users",
          path: "users",
          // component: PageUsersComponent,
          components: {
            default: PageUsersComponent,
            // title: DefaultTitleComponent,
            // navigator: DefaultNavigatorComponent,
            menu: DefaultMenuComponent
          },
          meta: {
            title: "Пользователи"
            // panelTitle: "Employees panel"
          },
          children: []
        },
        {
          name: "mobile-users",
          path: "mobile-users",
          // component: PageUsersComponent,
          components: {
            default: PageMobileUsersComponent,
            // title: DefaultTitleComponent,
            // navigator: DefaultNavigatorComponent,
            menu: DefaultMenuComponent
          },
          meta: {
            title: "Пользователи мобильных устройств"
            // panelTitle: "Employees panel"
          },
          children: []
        },
        {
          name: "contracts",
          path: "contracts",
          // component: PageUsersComponent,
          components: {
            default: PageContractsComponent,
            // title: DefaultTitleComponent,
            // navigator: DefaultNavigatorComponent,
            menu: DefaultMenuComponent
          },
          meta: {
            title: "Контракты"
            // panelTitle: "Employees panel"
          },
          children: []
        },
        {
          name: "mobile-users-devices",
          path: "mobile-users-devices/:userId",
          // component: PageUsersComponent,
          components: {
            default: PageMobileUsersDevicesComponent,
            // title: DefaultTitleComponent,
            // navigator: DefaultNavigatorComponent,
            menu: DefaultMenuComponent
          },
          meta: {
            title: "Устройства"
            // panelTitle: "Employees panel"
          },
          children: []
        },
        {
          name: "contracts-organization",
          path: "contracts-organization/:organizationId",
          // component: PageUsersComponent,
          components: {
            default: PageContractsOrganizationComponent,
            // title: DefaultTitleComponent,
            // navigator: DefaultNavigatorComponent,
            menu: DefaultMenuComponent
          },
          meta: {
            title: "Организация"
            // panelTitle: "Employees panel"
          },
          children: []
        },
        {
          name: "kpi",
          path: "kpi",
          // component: PageUsersComponent,
          components: {
            default: PageKpiComponent,
            // title: DefaultTitleComponent,
            // navigator: DefaultNavigatorComponent,
            menu: DefaultMenuComponent
          },
          meta: {
            title: "KPI"
            // panelTitle: "Employees panel"
          },
          children: []
        },
        {
          name: "kpi-user",
          path: "kpi-user/:kpiId",
          // component: PageUsersComponent,
          components: {
            default: PageKpiUserComponent,
            // title: DefaultTitleComponent,
            // navigator: DefaultNavigatorComponent,
            menu: DefaultMenuComponent
          },
          meta: {
            title: "KPI - User"
            // panelTitle: "Employees panel"
          },
          children: []
        },
        {
          name: "kpi-user-history",
          path: "kpi-user-history/:userId/:kpiId",
          // component: PageUsersComponent,
          components: {
            default: PageKpiUserHistoryComponent,
            // title: DefaultTitleComponent,
            // navigator: DefaultNavigatorComponent,
            menu: DefaultMenuComponent
          },
          meta: {
            title: "История"
            // panelTitle: "Employees panel"
          },
          children: []
        },
        {
          name: "map",
          path: "map",
          // component: PageUsersComponent,
          components: {
            default: PageMapComponent,
            // title: DefaultTitleComponent,
            // navigator: DefaultNavigatorComponent,
            menu: DefaultMenuComponent
          },
          meta: {
            title: "Map"
            // panelTitle: "Employees panel"
          },
          children: []
        },
        {
          name: "gps-tracker",
          path: "gps-tracker",
          // component: PageUsersComponent,
          components: {
            default: PageGpsTrackerComponent,
            // title: DefaultTitleComponent,
            // navigator: DefaultNavigatorComponent,
            menu: DefaultMenuComponent
          },
          meta: {
            title: "gps-tracker"
            // panelTitle: "Employees panel"
          },
          children: []
        },
        {
          name: "seo",
          path: "seo",
          // component: PageUsersComponent,
          components: {
            default: PageSeoComponent,
            // title: DefaultTitleComponent,
            // navigator: DefaultNavigatorComponent,
            menu: DefaultMenuComponent
          },
          meta: {
            title: "Seo"
            // panelTitle: "Employees panel"
          },
          children: []
        }
      ]
    },
    {
      name: loginRoute.name,
      path: "/" + routeLangPrefix + "/login",
      component: LoginComponent,
      meta: {
        allowAnonymous: true,
        title: "Авторизация"
      }
    },
    {
      name: "404",
      path: "*",
      component: LoginComponent,
      meta: {
        allowAnonymous: true,
        title: "Авторизация"
      }
    }
  ]
});

let isGottenUser = false; // true если без авторизации
router.beforeEach((to, from, next) => {
  // debugger
  if (
    !to.params.lang &&
    to.matched.length > 0 &&
    !(to.matched.length == 1 && to.matched[0].path == "*")
  ) {
    const cl = Vue.$locale.currentLang;
    to.params.lang = cl;
    console.log("Vue.$locale.currentLang: ", cl);
    next(`/${cl}${to.path}`);
    return;
  }

  Vue.$locale.currentLang = to.params.lang;
  // next();// раскоментировать если без авторизации
  // return;// раскоментировать если без авторизации
  if (to.meta && to.meta.allowAnonymous) {
    next();
    return;
  }

  if (Vue.$api.isLoggedIn) {
    next();
    return;
  }
  if (isGottenUser) {
    next(loginRoute.name); //`${Vue.$locale.currentLang}/${loginRoute.name}`);
    return;
  }

  Vue.$api.AccountService.GetUserEvent.once(
    (response: WsResponseModel<UserResponse>) => {
      if (response.IsSuccess && response.Value) {
        Vue.$api.SetUser(response.Value);
        isGottenUser = true;
      }

      if (Vue.$api.User == null) {
        // console.log(`${Vue.$locale.currentLang}/${loginRoute.name}`);
        next(loginRoute.name); //`${Vue.$locale.currentLang}/${loginRoute.name}`);
      } else next();
    }
  );
  Vue.$api.AccountService.GetUser();
});

export default router;



// WEBPACK FOOTER //
// ./scripts/router.ts